
import axios from "axios";
let requests = axios.create({
  baseURL: "https://www.jqnmzy.cn",
  timeout: 5000,
  headers:{
    'Content-Type': "application/json;charset=UTF-8",
    withCredentials: true,
  }
});
 

requests.interceptors.request.use((config) => {
  return config;
});

requests.interceptors.response.use(
  (res) => {
   
    return res.data;
  },
  (err) => {
  
    console.log(err);
 
  }
);
export default requests;